import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import L from 'leaflet';

const SearchControl = ({ onSearchResult }) => {
  const map = useMap();

  useEffect(() => {
    const provider = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider,
      style: 'bar',
      autoComplete: true,
      autoCompleteDelay: 250,
      showMarker: true,
      retainZoomLevel: false,
      animateZoom: true,
      marker: {
        icon: new L.Icon.Default(),
        draggable: false,
      },
      maxMarkers: 1,
      retainZoomLevel: false,
      searchLabel: 'Enter location...',
      keepResult: true,
    });

    map.addControl(searchControl);

    map.on('geosearch/showlocation', (result) => {
      if (onSearchResult) {
        onSearchResult({
          lat: result.location.y,
          lng: result.location.x,
        });
      }
    });

    return () => map.removeControl(searchControl);
  }, [map, onSearchResult]);

  return null;
};

export default SearchControl;
